export default class disponibilidadEquipo{
	constructor($scope,
				$routeParams,
				method,
				disponibilidadEquipoService,
                teamService,
				$location,
                $uibModal,
				toastr
				){
		this.scope    = $scope;
		this.location = $location;
		this.toastr = toastr;
        this.modal = $uibModal;
		switch (method) {
			case 'list':
				this.list(disponibilidadEquipoService);
			break;
			case 'new':
				this.create(disponibilidadEquipoService, teamService);
			break;
			case 'view':
				this.view($routeParams, disponibilidadEquipoService, teamService);
			break;
		}
	}

	list(disponibilidadEquipoService){
        let self = this.scope;
        disponibilidadEquipoService.getAll().then((resp, err) => {
			self.disponibilidades = resp.data.message;
		});

        self.getItemPage = (item) => {
            let index = self.disponibilidades.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, disponibilidadEquipoService);
        /*this.scope.inAction = false;
		this.scope.eliminar = (id, index) => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                disponibilidadEquipoService.delete({_id: id}).then((resp) => {
                    if (resp.data.success === true) {
                        this.toastr.success('Disponibilidad eliminada correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        window.location.reload();
                    }
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al eliminar la disponibilidad!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};*/
	}

	create(disponibilidadEquipoService,teamService){

        this.scope.aux = {
            fechaValida : false,
            fechaInicioValida: false,
            fechaTerminoValida: false
        };
        teamService.getAll()
            .then((resp) => {
                this.scope.teams = resp.data.message;
            });

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                this.scope.disponibilidadEquipo.id_equipo = this.scope.aux.team._id;
                this.scope.disponibilidadEquipo.nombre_equipo = this.scope.aux.team.nombre;
                disponibilidadEquipoService.save(this.scope.disponibilidadEquipo).then((resp) => {
                    this.toastr.success('Disponibilidad creada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/disponibilidad_equipo');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al crear la disponibilidad!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};

        this.scope.$watch('aux.fecha', (nuevo) => {
            this.scope.aux.fechaValida = angular.isDefined(nuevo);
        });
        this.scope.$watch('aux.fecha_inicio', (nuevo) => {
            this.scope.aux.fechaInicioValida = angular.isDefined(nuevo);
        });
        this.scope.$watch('aux.fecha_termino', (nuevo) => {
            this.scope.aux.fechaTerminoValida = angular.isDefined(nuevo);
        });
	}

	view($routeParams,
         disponibilidadEquipoService, teamService){

        this.scope.aux = {
            fechaValida : false,
            fechaInicioValida: false,
            fechaTerminoValida: false
        };

        disponibilidadEquipoService.getById({_id: $routeParams.id}).then((resp) => {
			this.scope.disponibilidadEquipo = resp.data.message;
			if(this.scope.disponibilidadEquipo.flag_turno) {
                this.scope.disponibilidadEquipo.flag_turno = "true";
            } else {
                this.scope.disponibilidadEquipo.flag_turno = "false";
            }
            this.scope.aux.fecha_inicio = moment(this.scope.disponibilidadEquipo.fecha_inicio);
            this.scope.aux.fecha_termino = moment(this.scope.disponibilidadEquipo.fecha_termino);
            this.scope.aux.fecha = moment(this.scope.disponibilidadEquipo.fecha);
            teamService.getAll()
                .then((resp) => {
                    this.scope.teams = resp.data.message;
                    for (var el in this.scope.teams) {
                        let element = this.scope.teams[el];
                        if (this.scope.disponibilidadEquipo.id_equipo === element._id) {
                            this.scope.aux.team = element;
                        }
                    }
                });
		}).catch((er) => {
			console.log(er);
		});

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                this.scope.disponibilidadEquipo.id_equipo = this.scope.aux.team._id;
                this.scope.disponibilidadEquipo.nombre_equipo = this.scope.aux.team.nombre;
                disponibilidadEquipoService.update(this.scope.disponibilidadEquipo).then((resp) => {
                    this.toastr.success('Disponibilidad modificada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/disponibilidad_equipo');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al modificar la disponibilidad!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};

        this.scope.$watch('aux.fecha', (nuevo) => {
            this.scope.aux.fechaValida = angular.isDefined(nuevo);
        });
        this.scope.$watch('aux.fecha_inicio', (nuevo) => {
            this.scope.aux.fechaInicioValida = angular.isDefined(nuevo);
        });
        this.scope.$watch('aux.fecha_termino', (nuevo) => {
            this.scope.aux.fechaTerminoValida = angular.isDefined(nuevo);
        });
	}

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Disponibilidad</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar la disponibilidad: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.nombre_equipo;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: object._id}).then((resp) => {
                    self.scope.disponibilidades.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Disponibilidad eliminada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar disponibilidad!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}


// WEBPACK FOOTER //
// ./app/js/controllers/disponibilidad_equipo/disponibilidadEquipo.js